module.exports = __webpack_public_path__ + "media/button.5956a851.mp3";